<template>	
	<main>
		<div>
			<article class="page-body contact">
				<section class="form">
					<snippet-content slug="contact-us" />					
					<contacts-form/>
				</section>
				<section v-html="page.body" class="details" />
			</article>
		</div>
	</main>
</template>

<script>
import ContactsForm from '@/features/contacts/components/public/ContactsForm'
import { pagesComputed } from '@/features/pages/store'
export default {
	components: {
		ContactsForm
	},
	computed: {
		...pagesComputed,
		page() {            
            return this.pages.find(temp => temp.slug == 'contact')
        },
	}
}
</script>
